<template>
  <div class="app flex-row align-items-center bg-black">
    <div class="container-fluid">
      <b-row class="justify-content-center scan-box">
        <b-col sm="10" lg="8">
          <template v-if="scanDone === true">
            <div class="text-center">
                <img class="mb-20 logo-scan" :src="`/logo2.svg`">
                <template v-if="totalQuota === ''">
                  <div class="font-bold color-red">There is no schedule</div>
                </template>
                <template v-else>
                  <div class="font-bold color-white">Welcome to PARADIGM,</div>
                </template>
                <div class="color-white">{{ realtime }}</div>
            </div>
            <div class="color-white">
              <div class="row justify-content-center">
                <div class="col-sm-12 col-lg-4 mb-50">
                  <div class="mt-20">
                    <img :src="imgProfile" class="w-100 img-fix" >
                  </div>
                  <div class="mt-20 text-center">
                    <div class="font-700">{{memberName}}</div>
                    <div>ID {{idMember}}</div>
                  </div>
                  <div class="mt-15 text-center">
                    <div>Your visit</div>
                    <template v-if="totalQuota === ''">
                      <div class="font-bold">0/0</div>
                    </template>
                    <template v-else>
                      <div class="font-bold">{{quota}}/{{totalQuota}}</div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="text-center">
                <img class="mb-20 logo-scan" :src="`/logo2.svg`">
                <div class="font-bold color-white">Welcome to PARADIGM Fitness, 
                  <br>Scan your QR Code here to enter the gym</div>
            </div>
            <div class="color-white">
              <div class="row justify-content-center">
                <div class="col-sm-12 col-lg-4 mb-50">
                  <div>
                    <qrcode-reader :camera="cameraOn" :paused="false" :class="['qr-scanner mt-20 mb-20', cameraOn ? '' : 'hidden']" @decode="onDecode"></qrcode-reader>
                  </div>
                  <div :class="['text-center mt-15', cameraOn ? 'hidden' : '']">
                    <b-form-select v-model="studioId">
                      <option v-for="item in optStudio" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                    <button @click="activeCamera" class="btn-primary mt-10 w-100" >Scan QR Code</button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { QrcodeReader } from 'vue-qrcode-reader'

export default {
  name: 'ScanClasses',
  components: {
    'qrcode-reader': QrcodeReader
  },
  data: () => ({
    imgProfile: 'https://via.placeholder.com/300x250',
    memberName: 'Member Name',
    classesName: 'None',
    totalQuota: '',
    quota: '',
    idMember: '123',
    studioId: 1,
    cameraOn: false,
    scanDone: false,
    optStudio: null,
    realtime: '',
    loginData: {
      email: '',
      password: ''
    }
  }),
  methods: {
    activeCamera () {
      this.cameraOn = true
      setTimeout(()=>{
        this.$nextTick(() =>{
          this.cameraOn = false
        })
      }, 6000);
    },
    realTimeClock () {
      // moment.locale('en')
      // // var self = this
      // var self = this
      this.realtime = moment().format('MMMM Do YYYY, h:mm:ss a')
      // setInterval(self.realTimeClock, 1000)
      // this.realtime = moment().format('MMMM Do YYYY, h:mm:ss a')
      // return moment(value).format('dddd, DD MMMM YYYY')
    },
    onDecode (decodedString) {
      axios.get('fitness/v1/scanning/class_attendance/' + this.studioId + '/' + decodedString).then(response => {
        // console.log('test', response.data.data.rows)
        this.imgProfile = Auth.apiUrl + 'fitness/v1/img/member/' + response.data.member.thumbnail
        this.memberName = response.data.member.first_name + response.data.member.last_name
        this.idMember = response.data.member.id
        this.totalQuota = response.data.current_active_package
        this.quota = response.data.total_active_package
        this.$toast.success(response.data.message, 'Success', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
      }).catch(error => {
        // console.log('error test', error.response.data.member.address)
        this.imgProfile = Auth.apiUrl + 'fitness/v1/img/member/' + error.response.data.member.thumbnail
        this.memberName = error.response.data.member.first_name + error.response.data.member.last_name
        this.idMember = error.response.data.member.id
        this.$toast.success('There is no schedule', 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
      })
      this.cameraOn = false
      this.scanDone = true
      // alert('test')
      setTimeout(()=>{
        this.$nextTick(() =>{
          this.scanDone = false
        })
      }, 7000);
    }
  },
  created () {
    this.realTimeClock()
    axios.get('fitness/v1/studio?sorting=id&sorting_type=asc&status=active').then(response => {
      this.optStudio = response.data.data.rows
      // console.log('test', response.data.data.rows)
    }).catch(error => {
      console.log('error', error)
    })
  }
}
</script>
